import {
  TBaseBulkDeleteResponseDto,
  TBaseCreateResponseDto,
  TBaseDeleteResponseDto, TBaseGetAllResponseDto, TBaseGetResponseDto, TBaseUpdateResponseDto
} from './common/t-base-response.dto';
import {AutoMap} from '@automapper/classes';
import {
  TBaseBulkDeleteRequestDto,
  TBaseCreateRequestDto, TBaseDeleteRequestDto,
  TBaseGetAllRequestDto,
  TBaseGetRequestDto,
  TBaseUpdateRequestDto
} from './common/t-base-request.dto';
import {SourceTypeEnum} from '../enums/source-type.enum';
import {SourceReviewFrequencyWeightTypeEnum} from '../enums/source-review-frequency-weight-type.enum';

export class SourceGetAllRequestDto extends TBaseGetAllRequestDto {}
export class SourceGetAllResponseDto extends TBaseGetAllResponseDto {
  @AutoMap()
  title!: string;
  @AutoMap()
  type!: SourceTypeEnum | null;
  @AutoMap()
  author!: string;
  @AutoMap()
  isStarred!: boolean;
}

export class SourceGetRequestDto extends TBaseGetRequestDto {}
export class SourceGetResponseDto extends TBaseGetResponseDto {
  @AutoMap()
  title!: string;
  @AutoMap()
  type!: SourceTypeEnum | null;
  @AutoMap()
  reviewFrequencyWeightType!: SourceReviewFrequencyWeightTypeEnum | null;
  @AutoMap()
  description!: string;
  @AutoMap()
  author!: string;
  @AutoMap()
  url!: string;
  @AutoMap()
  isStarred!: boolean;
}

export class SourceCreateRequestDto extends TBaseCreateRequestDto {
  @AutoMap()
  title!: string;
  @AutoMap()
  type!: SourceTypeEnum | null;
  @AutoMap()
  reviewFrequencyWeightType!: SourceReviewFrequencyWeightTypeEnum | null;
  @AutoMap()
  description!: string;
  @AutoMap()
  author!: string;
  @AutoMap()
  url!: string;
  @AutoMap()
  isStarred!: boolean;
}
export class SourceCreateResponseDto extends TBaseCreateResponseDto {}

export class SourceUpdateRequestDto extends TBaseUpdateRequestDto {
  @AutoMap()
  title!: string;
  @AutoMap()
  type!: SourceTypeEnum | null;
  @AutoMap()
  reviewFrequencyWeightType!: SourceReviewFrequencyWeightTypeEnum | null;
  @AutoMap()
  description!: string;
  @AutoMap()
  author!: string;
  @AutoMap()
  url!: string;
  @AutoMap()
  isStarred!: boolean;
}
export class SourceUpdateResponseDto extends TBaseUpdateResponseDto {}

export class SourceDeleteRequestDto extends TBaseDeleteRequestDto {}
export class SourceDeleteResponseDto extends TBaseDeleteResponseDto {}

export class SourceBulkDeleteRequestDto extends TBaseBulkDeleteRequestDto {}
export class SourceBulkDeleteResponseDto extends TBaseBulkDeleteResponseDto {}
